import { Global } from "src/app/utils/global";

export const environment = {
  production: false,
  version: '1.0.14',
  Global,
  API_GENERAL_URL: 'https://wa-p-skomex-api-weu.azurewebsites.net/api/',
}
